export function focusControlElement(attributeElement) {
    const controlElement = attributeElement.querySelector(`
            input[type="number"]
            input[type="text"],
            input[type="radio"],
            input[type="checkbox"],
            textarea,
            select
          `);
    if (controlElement && "focus" in controlElement) {
        controlElement.focus({ preventScroll: true });
    }
}
//# sourceMappingURL=focusControlElement.js.map